var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"fill-current",class:_vm.classes,attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"17.5 15 11.2 20","height":_vm.height}},[_c('path',{attrs:{"d":"M27.3 34.7L17.6 25l9.7-9.7 1.4 1.4-8.3 8.3 8.3 8.3z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }